import { Component } from '@angular/core';

@Component({
  selector: 'peca-kanban',
  templateUrl: './kanban.component.html',
  styleUrl: './kanban.component.scss',
})
export class KanbanComponent {}
